import { StyledMainSection } from "@/styles/global";
import styled from "styled-components";

const Section = styled(StyledMainSection)``;

const Grid = styled.div`
  width: calc(100% + 0.4vw);
  aspect-ratio: 4 / 2;
  position: relative;
  margin-left: -0.2vw;
`;

const ImageWrapper = styled.div`
  position: absolute;
  display: flex;
  padding: 0.4vw;
`;

const ImageContainer = styled.div`
  position: relative;
  height: 100%;
  width: 100%;
  border-radius: 1vw;
  justify-content: center;
  align-items: center;
  overflow: hidden;
`;

const Image1 = styled(ImageWrapper)`
  top: 0%;
  left: 0%;
  width: 40%;
  height: 60%;
`;

const Image2 = styled(ImageWrapper)`
  top: 0%;
  left: 40%;
  width: 60%;
  height: 40%;
`;

const Image3 = styled(ImageWrapper)`
  top: 60%;
  left: 0%;
  width: 40%;
  height: 40%;
`;

const Image4 = styled(ImageWrapper)`
  top: 40%;
  left: 40%;
  width: 25%;
  height: 60%;
`;

const Image5 = styled(ImageWrapper)`
  top: 40%;
  left: 65%;
  width: 35%;
  height: 60%;
`;

const S = {
  Section,
  Grid,
  ImageContainer,
  Image1,
  Image2,
  Image3,
  Image4,
  Image5,
};

export default S;
